import { formatString } from '@common/utils/formatString';
import { doesTranslateKeyExist, translateKey } from '../translate';

function errorTranslation(error: string, showError: boolean = true): string {
    if (doesTranslateKeyExist(`validation.${error}`)) {
        return translateKey(`validation.${error}`);
    }
    switch (error) {
        case 'koi_time':
        case 'koi_date':
            return translateKey('validation.general');
        default:
            return showError ? `*** Unknown validation error: ${error} ***` : error;
    }
}

export function getValidationErrorTranslation(error?: string, errorArgs?: Record<string, string> | string[]) {
    let translatedError: string | undefined = undefined;

    if (error) {
        translatedError = errorTranslation(error);
    }

    if (translatedError && errorArgs) {
        translatedError = formatString(translatedError, errorArgs);
    }

    return translatedError;
}

export function getTelephoneNumberError(error?: string) {
    if (error === 'string_base') {
        return 'onePhoneNumberRequired';
    } else if (error === 'string_pattern.base') {
        return 'invalidPhoneNumber';
    }

    return error;
}
